// https://material.io/resources/icons/?style=baseline

export const getSidebarItems = () => {
  return [
    {
      title: "inventories",
      icon: "inventory",
      link: "/inventories",
      children: [
        {
          title: "inventory_summary",
          link: "/summaries"
        },
        {
          title: "fixed_assets",
          link: "/assets"
        }
      ]
    },
    {
      title: "clients",
      icon: "group",
      link: "/clients"
    },
    {
      title: "users",
      icon: "assignment_ind",
      link: "/users"
    },
    {
      title: "accounting",
      icon: "settings",
      link: "/accountingConfiguration"
    },
    {
      title: "employees",
      icon: "engineering",
      link: "/employees"
    },
    {
      title: "vendors",
      icon: "store",
      link: "/vendors"
    },
    {
      title: "locations",
      icon: "location_on",
      link: "/locations"
    },
    {
      title: "import_data",
      icon: "upload_file",
      link: "/import"
    },
    {
      title: "recycling",
      icon: "recycling",
      link: "/recycling",
      children: [
        {
          title: "inactive_assets",
          link: "/inactive-assets"
        }
      ]
    },
    {
      title: "audit",
      icon: "menu_book",
      link: "/audit",
      children: [
        {
          title: "change_logs",
          link: "/change-logs"
        }
      ]
    }
  ];
}
